import options from './backdrop.directive';

export default {
    selector: 'dtBackdrop',
    options
};
